// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"558":"4572d642","2532":"4572d642","7485":"4572d642"}[chunkId] + ".chunk.css";
};